import React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok";
import * as styles from "./richtext.module.css"

const LandingParagraph = ({ blok }) => {
  const textAlign = blok.textAlign ? blok.textAlign : 'text-center'
  // console.log(blok)
  return (
    <div id={blok?.id} {...storyblokEditable(blok)} style={{ 
      backgroundColor: `${blok.bgColor?.color}`,
      marginTop: `${blok.marginTop}px`, marginBottom: `${blok.marginBottom}px`, color: `${blok.textColor?.color}`}} >
      <div className="container max-w-[790px] mx-auto px-5 md:px-10 py-10 text-center"
        style={{ 
          paddingTop: `${blok.paddingTop}px`, paddingBottom: `${blok.paddingBottom}px`, 
          backgroundColor: `${blok.textBgColor?.color}`,
          borderWidth: `${blok.borderWidth}px`, borderColor: `${blok.borderColor?.color}` }} 
          {...storyblokEditable(blok)}>
        <h2 className="text-3xl font-bold font-serif">{blok.title}</h2>
        <div className={`${textAlign} ${styles.richText}`} dangerouslySetInnerHTML={{ __html: renderRichText(blok.text) }}></div>
      </div>
    </div >
  )
}

export default LandingParagraph
